import { CALL_API } from "redux-api-middleware";
import api from "apis/user";
import { ho } from "apis/homeowner/ho";
import {
  REQUEST_CASELIST_RESULTS,
  RECEIVE_CASELIST_RESULTS,
  ERROR_CASELIST_RESULTS,

  REQUEST_DASHBOARD_RESULTS,
  RECEIVE_DASHBOARD_RESULTS,
  ERROR_DASHBOARD_RESULTS,

  REQUEST_PROFILE_RESULTS,
  RECEIVE_PROFILE_RESULTS,
  ERROR_PROFILE_RESULTS,

  REQUEST_NOTIFICATIONS_RESULTS,
  RECEIVE_NOTIFICATIONS_RESULTS,
  ERROR_NOTIFICATIONS_RESULTS,

  REQUEST_STATISTICS_RESULTS,
  RECEIVE_STATISTICS_RESULTS,
  ERROR_STATISTICS_RESULTS,

  REQUEST_CHANGESTATUS_RESULTS,
  RECEIVE_CHANGESTATUS_RESULTS,
  ERROR_CHANGESTATUS_RESULTS,

  CONTROLID_CHANGE,
  CASEFILTER_CHANGE,
  CASEFILTER_CLEARFILTER,

  REQUEST_GRID_FILTERS_RESULTS,
  RECEIVE_GRID_FILTERS_RESULTS,
  ERROR_GRID_FILTERS_RESULTS,

  REQUEST_GRID_FILTER_MENUS_RESULTS,
  RECEIVE_GRID_FILTER_MENUS_RESULTS,
  ERROR_GRID_FILTER_MENUS_RESULTS,

  REQUEST_CASE_HOLD_STATUS,
  RECEIVE_CASE_HOLD_STATUS,
  ERROR_RETRIEVE_CASE_HOLD_STATUS

} from "typeConstants";
import responseHandler from "responseHandler";

const changeControlNumber = (controlNumber) => ({
  type: CONTROLID_CHANGE,
  payload: controlNumber,
});

const changeGridFilters = (newGridFilters) => ({
  type: CASEFILTER_CHANGE,
  payload: newGridFilters
});

const clearFilter = () => {
  return (dispatch) => {
    dispatch({
      type: CASEFILTER_CLEARFILTER,
      payload: ""
    });
  };
};

const getDashboard = () => {
  return (dispatch, getState) => {
    const gridFilters = getState().dashboard.gridFilters;
    dispatch({
      [CALL_API]: {
        endpoint: api.dashboard(),
        method: "POST",
        body: JSON.stringify(gridFilters),
        types: [
          REQUEST_DASHBOARD_RESULTS,
          {
            type: RECEIVE_DASHBOARD_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_DASHBOARD_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getCaseList = () => {
  return (dispatch, getState) => {
    const gridFilters = getState().dashboard.gridFilters;
    dispatch({
      [CALL_API]: {
        endpoint: api.caseList(),
        method: "POST",
        body: JSON.stringify(gridFilters),
        types: [
          REQUEST_CASELIST_RESULTS,
          {
            type: RECEIVE_CASELIST_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_CASELIST_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getProfile = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getProfile(),
        method: "GET",
        types: [
          REQUEST_PROFILE_RESULTS,
          {
            type: RECEIVE_PROFILE_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_PROFILE_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getNotifications = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.notifications(),
        method: "GET",
        types: [
          REQUEST_NOTIFICATIONS_RESULTS,
          {
            type: RECEIVE_NOTIFICATIONS_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_NOTIFICATIONS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getStatistics = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.statistics(),
        method: "GET",
        types: [
          REQUEST_STATISTICS_RESULTS,
          {
            type: RECEIVE_STATISTICS_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_STATISTICS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const changeStatus = (controlNumber, action) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        //Using Magic String for the new worflow feature in order to segment these actions from existing actions VERY AWESOME!!!
        endpoint: ho.workflowMethod(controlNumber, "custom", action),
        method: "POST",
        types: [
          REQUEST_CHANGESTATUS_RESULTS,
          {
            type: RECEIVE_CHANGESTATUS_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  responseHandler.success(data.message ? data.message : "Success!", dispatch);
                  return data;
                })
          }, {
            type: ERROR_CHANGESTATUS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getGridFilters = (Code = "Insurance") => {
  let endp = null;
  if (Code === "Insurance") {
    endp = ho.getGridFiltersInsurance();
  } else {
    endp = ho.getGridFiltersValuation();
  }
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: endp,
        method: "GET",
        types: [
          REQUEST_GRID_FILTERS_RESULTS,
          {
            type: RECEIVE_GRID_FILTERS_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_GRID_FILTERS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const getGridFilterMenus = () => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: ho.getGridFilterMenus(),
        method: "GET",
        types: [
          REQUEST_GRID_FILTER_MENUS_RESULTS,
          {
            type: RECEIVE_GRID_FILTER_MENUS_RESULTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_GRID_FILTER_MENUS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

export const getCaseHoldStatus = (controlNumber) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: ho.caseHoldStatus(controlNumber),
        method: "GET",
        types: [
          REQUEST_CASE_HOLD_STATUS,
          {
            type: RECEIVE_CASE_HOLD_STATUS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_RETRIEVE_CASE_HOLD_STATUS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

export {
  getDashboard,
  getCaseList,
  getProfile,
  getNotifications,
  getStatistics,
  changeGridFilters,
  changeControlNumber,
  changeStatus,
  clearFilter,
  getGridFilters,
  getGridFilterMenus
};